import AttributePanel from "../AttributePanel/AttributePanel";
import AttributeIconPanel from "../AttributeIconPanel/AttributeIconPanel";
import StatBoard from "../../../../utils/game/mechanics/StatBoard";
import FlexColumn from "../../../../common/components/layout/Flexbox/FlexColumn";
import FlexRow from "../../../../common/components/layout/Flexbox/FlexRow";

import awarenessIcon from "../../../../assets/images/character_sheet/svg/attributes/awareness.svg";
import wgtAllowIcon from "../../../../assets/images/character_sheet/svg/attributes/wgtAllow.svg";
import regenIcon from "../../../../assets/images/character_sheet/svg/attributes/regen.svg";
import survivalIcon from "../../../../assets/images/character_sheet/svg/attributes/survival.svg";
import willpowerIcon from "../../../../assets/images/character_sheet/svg/attributes/willpower.svg";
import stealthIcon from "../../../../assets/images/character_sheet/svg/attributes/stealth.svg";

type Props = {
    alignment?: "start" | "center" | "end";
    statBoard: StatBoard;
    onAttributeTitleClick?: (attributeName: string) => void;
    useIconAttributes?: boolean;
};

export default function AttributesContainer({
    alignment,
    statBoard,
    onAttributeTitleClick,
    useIconAttributes = true,
}: Props): JSX.Element {
    return (
        <FlexColumn width="full" style={{ marginBottom: "4px" }}>
            <FlexRow alignment="center">
                <span
                    style={{
                        fontSize: "80%",
                        fontWeight: "bold",
                        marginTop: "1px",
                        padding: "4px 40px",
                        border: "1px solid black",
                        borderRadius: "12px",
                        userSelect: "none",
                        backgroundColor: "#b1bbbd"
                    }}
                >
                    Attributes
                </span>
            </FlexRow>
            {useIconAttributes ? 
                <FlexColumn>
                    <FlexRow gap={8}>
                        <AttributeIconPanel icon={wgtAllowIcon} statBoard={statBoard} statKey={"WGTALL"} onIconClick={() => {onAttributeTitleClick?.("Weight Allowance")}} />
                        <AttributeIconPanel icon={survivalIcon} statBoard={statBoard} statKey={"SUR"} onIconClick={() => {onAttributeTitleClick?.("Survival")}} />
                        <AttributeIconPanel icon={regenIcon} statBoard={statBoard} statKey={"REG"} onIconClick={() => {onAttributeTitleClick?.("Regen")}} />
                    </FlexRow>
                    <FlexRow gap={8}>
                        <AttributeIconPanel icon={awarenessIcon} statBoard={statBoard} statKey={"AWA"} onIconClick={() => {onAttributeTitleClick?.("Awareness")}} />
                        <AttributeIconPanel icon={willpowerIcon} statBoard={statBoard} statKey={"WIL"} onIconClick={() => {onAttributeTitleClick?.("Willpower")}} />
                        <AttributeIconPanel icon={stealthIcon} statBoard={statBoard} statKey={"STLTH"} onIconClick={() => {onAttributeTitleClick?.("Stealth")}} />
                    </FlexRow>
                </FlexColumn> 
                :
                 <FlexRow alignment={alignment} wrap={true}>
                    <AttributePanel statBoard={statBoard} statKey="WGTALL" onAttributeTitleClick={() => {onAttributeTitleClick?.("Weight Allowance")}} />
                    <AttributePanel statBoard={statBoard} statKey="SUR" onAttributeTitleClick={() => {onAttributeTitleClick?.("Survival")}} />
                    <AttributePanel statBoard={statBoard} statKey="REG" onAttributeTitleClick={() => {onAttributeTitleClick?.("Regen")}} />
                    <AttributePanel statBoard={statBoard} statKey="AWA" onAttributeTitleClick={() => {onAttributeTitleClick?.("Awareness")}} />
                    <AttributePanel statBoard={statBoard} statKey="WIL" onAttributeTitleClick={() => {onAttributeTitleClick?.("Willpower")}} />
                    <AttributePanel statBoard={statBoard} statKey="STLTH" onAttributeTitleClick={() => {onAttributeTitleClick?.("Stealth")}} />
                </FlexRow>
            }
        </FlexColumn>
    );
}
